var hashtag_default = {
  "fontElementMap": "FliWd",
  "hashtag": "_-13sl"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
